import { FC, useEffect, useState } from "react";
import { Avatar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../../../common/routesUtils";
import { useAuthentication } from "../../../../hooks/useAuthentication";

/**
 * UserDisplayData renders the element that indicates the current user display data, such as email, first name and last name.
 * This component should be used inside the application top bar.
 */
const UserDisplayData: FC = () => {
	const { user } = useAuthentication();
	const navigateTo = useNavigate();

	const [initials, setInitials] = useState<string>();

	useEffect(() => {
		const f = user?.firstName.substring(0, 1) ?? "";
		const l = user?.lastName.substring(0, 1) ?? "";

		setInitials(`${f}${l}`);
	}, [user]);

	return user ? (
		<Avatar className="top-bar-user-avatar" onClick={() => navigateTo(AppRoutes.Account)}>
			{initials}
		</Avatar>
	) : (
		<></>
	);
};

export default UserDisplayData;
